var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { breathingAnimationKeyframes } from './breathingAnimationKeyframes';
// Utils
import { css } from 'styled-components';
export var breathingAnimation = function (delay) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  animation-name: ", ";\n  animation-duration: 1.2s;\n  animation-iteration-count: infinite;\n  animation-delay: ", ";\n  animation-timing-function: 'ease-in';\n"], ["\n  animation-name: ", ";\n  animation-duration: 1.2s;\n  animation-iteration-count: infinite;\n  animation-delay: ", ";\n  animation-timing-function: 'ease-in';\n"])), breathingAnimationKeyframes, delay ? delay + "s" : null); };
var templateObject_1;
//# sourceMappingURL=breathingAnimation.js.map